import { render } from "./MessageNotice.vue?vue&type=template&id=78dea8e5"
import script from "./MessageNotice.vue?vue&type=script&lang=js"
export * from "./MessageNotice.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__